import axios from 'axios';

import { axiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const listLoyaltyTransactions = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV1RootUrl()}/customer/${customerId}/loyalty-transaction?${queryString}`,
      axiosHeader()
    );
  }
  return axios.get(
    `${getV1RootUrl()}/customer/${customerId}/loyalty-transaction`,
    axiosHeader()
  );
};
